import { useTranslation } from 'next-i18next';

export interface FaqItem {
  question: string;
  answer: string;
  key: string;
}

const useQaList = () => {
  const { t } = useTranslation('faq');

  const faqList: FaqItem[] = [
    {
      key: 'faq-1',
      question: t('faq-1-question'),
      answer: t('faq-1-answer'),
    },
    {
      key: 'faq-2',
      question: t('faq-2-question'),
      answer: t('faq-2-answer'),
    },
    {
      key: 'faq-3',
      question: t('faq-3-question'),
      answer: t('faq-3-answer'),
    },
    {
      key: 'faq-4',
      question: t('faq-4-question'),
      answer: t('faq-4-answer'),
    },
    {
      key: 'faq-5',
      question: t('faq-5-question'),
      answer: t('faq-5-answer'),
    },
    {
      key: 'faq-6',
      question: t('faq-6-question'),
      answer: t('faq-6-answer'),
    },
    {
      key: 'faq-7',
      question: t('faq-7-question'),
      answer: t('faq-7-answer'),
    },
    {
      key: 'faq-8',
      question: t('faq-8-question'),
      answer: t('faq-8-answer'),
    },
  ];

  return {
    faqList,
  };
};

export default useQaList;
